import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {SessionActions} from "../shared/actions/session.actions";
import {IAppState} from "../shared/redux-store/store";
import {NgRedux} from "@angular-redux/store";
import {AdminUnitActions} from "../shared/actions/admin-unit.actions";
import {AbstractVisbosComponent} from "../core/visbos-core/components/abstract-visbos.component";

@Component({
  selector: 'vb-visbos-client',
  templateUrl: './visbos-client.component.html',
  styleUrls: ['./visbos-client.component.css']
})
export class VisbosClientComponent extends AbstractVisbosComponent implements OnInit {

  today = new Date();


  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef, private ngRedux: NgRedux<IAppState>,
              private adminUnitActions: AdminUnitActions) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    this.addSubscription(this.sessionActions.fetchAuthorizedUser(this.ngRedux.getState().session.token).subscribe());
    this.addSubscription(this.adminUnitActions.retrieveAdminUnitData(this.activeAdminUnitCuid$).subscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-client/visbos-client.component.ts